import { LOYALTY_FIJI_DOUBLE_POINTS_CAMPAIGN } from 'loyalty/constants/loyaltyEarn'

function getLoyaltyFijiDoublePointsCampaignEarnKey(
  propertyCountryCode: string | undefined,
): string | undefined {
  const now = new Date()
  if (now < new Date(LOYALTY_FIJI_DOUBLE_POINTS_CAMPAIGN.startDate) || now >= new Date(LOYALTY_FIJI_DOUBLE_POINTS_CAMPAIGN.endDateExclusive)) {
    return undefined
  }
  if (propertyCountryCode?.toUpperCase() === 'FJ') {
    return LOYALTY_FIJI_DOUBLE_POINTS_CAMPAIGN.earnKey
  }
  return undefined
}

export default getLoyaltyFijiDoublePointsCampaignEarnKey
